import { Component, HostBinding, inject } from "@angular/core";
import { Shell, SiteWideAlert } from "../../common";

@Component({
    selector: 'tyt-page-shell',
    templateUrl: `./page-shell.component.html`,
    styleUrls: ['./page-shell.component.scss']
})
export class PageShellComponent {
    private shell = inject(Shell);
    alerts: SiteWideAlert[] = [];

    ngOnInit() {
        this.shell.alertsChanged.subscribe(alerts => this.alerts = alerts);
    }
    
    @HostBinding('class.chromeless')
    get chromeless() {
        return this.shell.chromeless;
    }
}